import React, { Component } from 'react'
import { NavHashLink } from 'react-router-hash-link'
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem } from 'reactstrap'
import './index.scss'

class Menu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      fixed: ''
    }
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }
  handleScroll = () => {
    if (window.scrollY > 230) {
      this.setState({ fixed: 'top' })
    } else {
      this.setState({ fixed: 'none' })
    }
  }
  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }
  render() {
    return (
      <>
        <div className="ch-menu">
          <Navbar dark expand={'md'} fixed={this.state.fixed}>
            <div className="container-lg p-0">
              <NavbarBrand tag={NavHashLink} to="/#home">
                ลูกชิ้น - ไส้กรอกนายฮั่ง
              </NavbarBrand>
              <NavbarToggler onClick={() => this.toggle()} />
              <Collapse isOpen={this.state.isOpen} navbar>
                <Nav className="m-auto" navbar>
                  <NavItem>
                    <NavHashLink to="/#home" smooth>
                      หน้าหลัก
                    </NavHashLink>
                  </NavItem>
                  <NavItem>
                    <NavHashLink to="/promotion-detail">โปรโมชั่น</NavHashLink>
                  </NavItem>
                  <NavItem>
                    <NavHashLink to="/product-detail">สินค้า</NavHashLink>
                  </NavItem>
                  <NavItem>
                    <NavHashLink to="/#about" smooth>
                      เกี่ยวกับเรา
                    </NavHashLink>
                  </NavItem>
                  <NavItem>
                    <NavHashLink to="/contact-detail">ที่ตั้ง & สาขา</NavHashLink>
                  </NavItem>
                </Nav>
              </Collapse>
            </div>
          </Navbar>
        </div>
      </>
    )
  }
}

export default Menu
